var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.avatarUrl)?_c('img',{staticClass:"w-full border border-gray-300 h-full rounded-full",attrs:{"src":_vm.avatarUrl,"alt":`${_vm.projectname} Avatar`}}):_c('avatar',{attrs:{"custom-style":{ width: '100%', height: '100%', fontSize: _vm.fontSizes[_vm.size] },"username":_vm.projectname}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }